module.exports = __webpack_public_path__ + "img/gb-eng.f337dc2c.svg";